export default __webpack_public_path__ + "static/media/326.7c1ea60b.gif";